export function updateStudent(data) {
    return {
        type: "UPDATE_STUDENT",
        student: data
    };
}

export function updateParent(data) {
    return {
        type: "UPDATE_PARENT",
        student: data
    };
}

export function updateStudentUser(data) {
    return {
        type: "UPDATE_STUDENT_USER",
        studentUser: data
    };
}

export function updateFirstLogin(data) {
    return {
        type: "UPDATE_FIRST_LOGIN",
        firstLogin: data
    };
}

export function updateTeacher(data) {
    return {
        type: "UPDATE_TEACHER",
        teacher: data
    };
}

export function updateChartData(data,rules,xLabel,yLabel) {
    return {
        type: "UPDATE_CHART_DATA",
        chartData: data,
        chartRules:rules,
        xLabel:xLabel,
        yLabel:yLabel
    };
}

export function updateFunctionUpdateNote(data) {
    return {
        type: "UPDATE_FUNCTION_UPDATE_NOTE",
        updateNote: data
    };
}

export function updateAppName(data) {
    return {
        type: "UPDATE_APPNAME",
        appName: data
    };
}

export function selectClass(data) {
    return {
        type: "SELECT_CLASS",
        lastClass: data
    };
}

export function studentLogout() {
    return {
        type: "LOGOUT"
    };
}

export function updateStudentAppsStatus(apps) {
    return {
        type: "UPDATE_STUDENT_APPS_STATUS",
        apps:apps
    };
}

export function updateStudentAccountTab(tabNum) {
    return {
        type: "UPDATE_STUDENT_ACCOUNT_TAB",
        tabNum:tabNum
    };
}

export function updateAppStates(appStates) {
    return {
        type: "UPDATE_STUDENT_APP_STATES",
        appStates:appStates
    };
}



// WEBPACK FOOTER //
// ./src/StudentsComponent/actions.js